/**
 * Điều khiển thiết bị — đi qua BFF (mdmquery), KHÔNG gọi thẳng NanoMDM.
 * Backend kiểm tra session + RBAC (theo vai trò) + location trước khi chuyển
 * lệnh tới NanoMDM bằng API key giữ ở server.
 */
import { api, idPath } from './client';
import { buildCommandPlist } from './plist';

/** Gửi APNs push — đánh thức thiết bị check-in. */
export function push(ids) {
  return api(`/devices/${idPath(ids)}/push`);
}

/**
 * Enqueue một MDM command. Backend phân loại RequestType để áp RBAC
 * (staff chỉ được lệnh an toàn). BẤT ĐỒNG BỘ: trả command_uuid, kết quả tới sau.
 */
export function enqueue(ids, command, { noPush = false } = {}) {
  const plist = typeof command === 'string' ? command : buildCommandPlist(command);
  const q = noPush ? '?nopush=1' : '';
  return api(`/devices/${idPath(ids)}/enqueue${q}`, { method: 'PUT', xml: plist });
}
